<!-- If more event info elements are needed in the future, consider using the existing `ms-event-info`
     component from Grid Module. -->
@let eventItem = eventCarouselItem();
@if (eventItem.titleData?.title) {
    <ms-event-detail-card-header [eventCarouselItem]="eventItem" />
}

<div [class]="isLargeScoreboard() ? 'event-detail-large-scoreboard' : 'event-detail-card-body'">
    @if (isSmallScoreboard()) {
        <ng-container *ngTemplateOutlet="smallScoreboardHeader" />
    }

    <div class="event-detail-wrapper">
        <div
            class="event-team-wrapper"
            [class.gridable-market-info-event-team-wrapper]="!eventItem.event.scoreboard.started && gridableMarketInfo().length">
            @for (participantInfo of participantInfos(); track $index; let i = $index) {
                <div class="event-team-info">
                    @if (participantInfo.isSingleContestant) {
                        <ms-participant-image
                            class="team-image"
                            [sportId]="eventItem.event.sport.id"
                            [participantImage]="participantInfo.participant.image"
                            [showLogoColor]="true" />
                    }
                    <div class="team-name-wrapper">
                        @if (participantInfo.rank) {
                            <div class="participant-rank">
                                {{ participantInfo.rank }}
                            </div>
                        }
                        <div class="team-name">{{ participantInfo.participant.name }}</div>

                        @if (participantInfo.participant.country) {
                            <span class="participant-country">({{ participantInfo.participant.country }})</span>
                        }
                    </div>
                </div>

                @let optionData = gridableMarketInfo()[i];
                @if (!eventItem.event.scoreboard.started && optionData) {
                    <div
                        class="event-gridable-info"
                        [msOptionIndicator]="!optionData.lineValue && optionData.isOnline ? optionData.option.nativePrice : undefined"
                        [msOptionIndicatorPriceId]="!optionData.lineValue && optionData.isOnline ? optionData.option.id : undefined">
                        @if (optionData.isOnline) {
                            {{ optionData.lineValue ? optionData.lineValue : (optionData.option.nativePrice | msNativePriceFormatter) }}
                        } @else {
                            <vn-icon name="theme-locked" size="12" />
                        }
                    </div>
                }
            }
        </div>
        <ms-grid-scoreboard [event]="eventItem.event" [hideScoreBoardColumnFooter]="true" />
    </div>

    @if (isLargeScoreboard()) {
        <div class="scoreboard-right-sec">
            <ds-divider class="divider" vertical variant="on-surface-high" />
            <ng-container *ngTemplateOutlet="largeScoreboardHeader" />
        </div>
    }
</div>

<ng-template #smallScoreboardHeader>
    @let eventItem = eventCarouselItem();
    <div class="event-top-info">
        <div class="live-info-wrapper">
            @if (eventItem.event.scoreboard.started) {
                <span class="carousel-live-icon"><vn-icon name="theme-spot-filled" size="6" /></span>
            }
            <ms-event-timer
                class="event-timer"
                [class.live-event-timer]="eventItem.event.scoreboard.started"
                [live]="eventItem.event.live"
                [start]="eventItem.event.startDate"
                [scoreboard]="eventItem.event.scoreboard"
                [scoreboardType]="scoreboardType()" />
            @if (liveEventInfo()) {
                <span class="live-event-info">{{ liveEventInfo() }}</span>
            }
        </div>
        <ms-grid-scoreboard-header class="grid-scoreboard-header" [event]="eventItem.event" />
    </div>
</ng-template>

<ng-template #largeScoreboardHeader>
    @let eventItem = eventCarouselItem();
    <div class="event-top-info">
        <div class="live-info-wrapper">
            <div class="timer-container">
                @if (!eventItem.event.scoreboard.isFinished && eventItem.event.scoreboard.started) {
                    <span class="live-icon"><vn-icon name="theme-spot-filled" size="6" /></span>
                }
                <ms-event-timer
                    class="event-timer"
                    [live]="eventItem.event.live"
                    [start]="eventItem.event.startDate"
                    [scoreboard]="eventItem.event.scoreboard"
                    [scoreboardType]="scoreboardType()" />
            </div>
            @if (liveEventInfo() && !eventItem.event.scoreboard.isFinished) {
                <span class="live-event-info">{{ liveEventInfo() }}</span>
            }
        </div>
        @if (broadcaster$ | async; as broadcaster) {
            <div class="broadcast-info">{{ broadcaster }}</div>
        }
        <ms-grid-scoreboard-header class="grid-scoreboard-header" [event]="eventItem.event" />
    </div>
</ng-template>
